import { aanpAuthOptions } from "./util";
import { apiUrl } from "../config";
import instance from "./instance";

export function getCheckout(registrationMembershipType, isEarlyReg, joinRenewMembershipType, promoCode) {
	return instance.get(`${apiUrl}/checkout/getCheckout?registrationMembershipType=${registrationMembershipType}&joinRenewMembershipType=${joinRenewMembershipType}&promoCode=${promoCode}&isEarlyReg=${isEarlyReg}`, aanpAuthOptions()).then(r => r.data);
}

export function submitPayment(payment) {	
	 return instance.post(`${apiUrl}/checkout/submitPayment`, { ...payment }, aanpAuthOptions()).then(r => r.data);
}

export function saveNoPaymentRegistration() {	
	 return instance.post(`${apiUrl}/checkout/saveNoPaymentRegistration`, null, aanpAuthOptions()).then(r => r.data);
}

export function quickCheckout() {
 	return instance.post(`${apiUrl}/checkout/quickCheckout`, null, aanpAuthOptions()).then(r => r.data);	
}